import React from 'react'
import { useSelector } from 'react-redux';
import RecentCardListContainer from '../RecentCardListContainer';

function VisitorsList({ title }) {
    const { user } = useSelector((state) => state.user);
    return (
        <RecentCardListContainer user={user} matches={user.whoViewedMyProfile} title={title} />
    )
}

export default VisitorsList